<template>
  <div class="flex items-center justify-start flex-1">
    <div class="inline-flex items-center">
      <MIcon name="thumbs-up" class="mx-1 text-secondary-green" size="lg" />
      <small class="font-semibold">{{ positiveFeedback }}</small>
    </div>
    <div class="inline-flex items-center ml-2">
      <MIcon name="thumbs-down" class="mx-1 text-secondary-red" size="lg" />
      <small class="font-semibold">{{ negativeFeedback }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackCount',
  props: {
    positiveFeedback: { type: Number, default: 0 },
    negativeFeedback: { type: Number, default: 0 },
  },
}
</script>
